import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4c16accd&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&id=4c16accd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16accd",
  null
  
)

export default component.exports